/**
 * A transparent, full-width block that adds vertical space between sections: 10 px by default,
 * or whatever height the caller passes in `css` (for example
 * ``<Spacer css={css`height: 100px;`} />``).
 * Imported by 67 components across the site.
 */
import React from "react";
import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";

/** Any `div` attribute, plus an Emotion `css` override. */
interface SpacerProps extends React.HTMLAttributes<HTMLDivElement> {
	css?: SerializedStyles; // For emotion css prop
}

const StyledSpacer = styled.div`
	display: block;
	height: 10px; /* Default height */
	width: 100%;
`;

/** Renders the spacer with the caller's `css` and `div` attributes. */
const Spacer: React.FC<SpacerProps> = ({ css: cssProp, ...props }) => {
	// Combine a transparent background with any passed css
	const combinedCss = css`
		background-color: transparent;
		${cssProp}
	`;

	return <StyledSpacer css={combinedCss} {...props} />;
};

export default Spacer;
